// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"231":"3b37b362858a798be917","610":"23aff928ca7400a262f3","678":"57d8ac4d4d24f62a0df3","898":"a6d83bc5fdd54240f910"}[chunkId] + ".js";
};